import React from 'react';
import SEO from "../components/seo";
import Layout from "../components/layout";
import { Banner } from '../components/Banner';

//Images
import homeBanner from '../images/homeBanner.jpg';
const styles = {
  backgroundImage: `url(${homeBanner})`,
}


const Cancellation = () => {
  return(
    <Layout>
    <SEO title="Cancellation" keywords={[`Garden`, `Vertical Garden`, `Office garden`]} />

    <section className="banner col-md-12" style={ styles }>
      <Banner heading="garden design for urban spaces" info="We design amazing gardens" />
    </section>

    <section className="section">
      <div className="container">
        <div className="text-center">
          <h2 className="heading heading--lg text-uppercase">refund/cancellation policy</h2>
        </div>
      </div>
    </section>

    <section>
      <div className="container">
        <ul>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">balcony garden</h3>
                <p className="info info--black ml-md-4">You can cancel your booking anytime till final confirmation of the project and design. In case of cancellation, we will refund the booking amount less Rs 1000/-. </p>
            </li>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">artificial grass</h3>
                <p className="info info--black ml-md-4">You can cancel your booking anytime till final confirmation of the project. In case of cancellation, we will refund the booking amount less Rs 1000/-. Cancellation is not possible post project confirmation.</p>
            </li>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">vertical garden</h3>
                <p className="info info--black ml-md-4">You can cancel your booking anytime till final confirmation of the project and design. In case of cancellation, we will refund the booking amount less Rs 1000/-. </p>
            </li>
            <li className="mb-5">
                <h3 className="heading heading--lg text-capitalize">customized projects(Terrace Garden/Landscaping)</h3>
                <p className="info info--black ml-md-4">You can cancel your booking anytime till final confirmation of the project and design. In case of cancellation, we will refund the booking amount less Rs 1000/-. </p>
            </li>
        </ul>
            
      </div>
    </section>
  </Layout>
  );
}

export default Cancellation;